module.exports = __webpack_public_path__ + "static/media/monkaO.916ae244.gif";